module.exports = __webpack_public_path__ + "fonts/Gilroy-Heavy.8d36efeb.ttf";